// src/utils/debug.js
// Force same-origin logging via Vercel proxy (no CORS)
export const sendToBackend = async (level, message, error = null) => {
  try {
    const res = await fetch(`/api/log/frontend`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        level,
        message,
        error: error ? String(error) : null,
        url: typeof window !== 'undefined' ? window.location.href : '',
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        time: new Date().toISOString(),
        source: 'frontend',
      }),
    });
    if (res.ok) {
      console.log(`[${level}] log sent:`, message);
    } else {
      console.warn('Log failed with status', res.status);
    }
  } catch (e) {
    // Swallow to avoid breaking the app on logger errors
    console.warn('Failed to send log to backend:', e);
  }
};

// Shorthand helpers
export const logInfo = (msg) => sendToBackend('INFO', msg);
export const logError = (msg, err) => sendToBackend('ERROR', msg, err);
export const logWarn = (msg) => sendToBackend('WARNING', msg);

